module.exports = __webpack_public_path__ + "static/Isha_back_Big-da18193724b417ce2900ab1dd0127813.png";